const comments = [
  {
    id: 1,
    name: '吃瓜第一线',
    avatar: '🍉',
    time: '20分钟前',
    content: '这个瓜我追了两天了，终于等到了后续！今日吃瓜的整理太及时了，比我自己刷微博效率高多了。每天早上蹲更新已经成习惯了，推荐给了好多朋友。',
    likes: 328,
  },
  {
    id: 2,
    name: '深夜吃瓜人',
    avatar: '🦉',
    time: '1小时前',
    content: '看完这个专题才发现我之前吃的是假瓜……信息的完整度真的很高，不是那种标题党。希望能多出一些深度分析的专题，感觉还能挖更多料。',
    likes: 256,
  },
  {
    id: 3,
    name: '瓜田守望者',
    avatar: '🔍',
    time: '2小时前',
    content: '作为资深吃瓜群众表示，这个站的热点追踪速度在全网都算快的。而且分类做得很好，想找什么类型的瓜都很方便。希望团队继续保持这个更新频率！',
    likes: 189,
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            💬 瓜友热评
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            看看其他吃瓜群众都在说什么
          </p>
        </div>

        <div className="max-w-3xl mx-auto grid grid-cols-1 gap-4">
          {comments.map((comment) => (
            <div
              key={comment.id}
              className="p-5 rounded-xl bg-background-50 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <span className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-lg flex-shrink-0">
                  {comment.avatar}
                </span>
                <div>
                  <div className="text-sm font-medium text-foreground-800 whitespace-nowrap">{comment.name}</div>
                  <div className="text-xs text-foreground-400 whitespace-nowrap">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                {comment.content}
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-heart-line text-primary-400"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}